import React from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '../../resources/constants/routes';

export const Banner: React.FC = () => {
    const location = useLocation();
    return (
        <>
            {location.pathname === ROUTES.LOGIN &&
                <div className="flex items-center justify-center py-4 font-semibold bg-primary text-primary-foreground text-center text-sm border-t-white border-t-2 max-md:mb-2">
                    Bienvenue dans votre nouvel Espace Gourmand !
                    Si vous avez déjà un compte, cliquez sur "Enregistrez-vous" pour créer votre nouveau mot de passe.
                </div>
            }
        </>
    )
}
